const firebaseConfig = {
	apiKey: 'AIzaSyD8Cbs8vtVhhomAvGwl9Etti3tsVpniGeQ',
	authDomain: 'ptp-web.firebaseapp.com',
	databaseURL: 'https://ptp-web.firebaseio.com',
	projectId: 'ptp-web',
	storageBucket: 'ptp-web.appspot.com',
	messagingSenderId: '1019382676067',
	appId: '1:1019382676067:web:5729dd328d18c93c3f1656',
	measurementId: 'G-RV2D4JY9J2',
};

export default firebaseConfig;
